// Hostname-aware Cognito config. Cognito user pool IDs and client IDs are
// public (they appear in OAuth redirect URLs), so hardcoding per host is fine
// and avoids the build-time-vs-runtime split that bit us when the same web
// bundle was deployed to multiple environments. Local dev (localhost) uses no
// auth — the AuthContext applies a DEV_BYPASS when no config is returned.
//
// When new prod stands up in 851725180781, fill in PROD_CONFIG below from the
// stack outputs and redeploy.

interface CognitoEnvConfig {
  userPoolId: string;
  userPoolClientId: string;
  region: string;
  domain: string;
}

const DEV_CONFIG: CognitoEnvConfig = {
  userPoolId: 'us-west-2_BNBupYG9x',
  userPoolClientId: '4f5pr7369gd4sgjb6sre3p7hri',
  region: 'us-west-2',
  domain: 'bsides-toolkit-auth-dev.auth.us-west-2.amazoncognito.com',
};

const PROD_CONFIG: CognitoEnvConfig = {
  userPoolId: 'us-west-2_8u17BKxCB',
  userPoolClientId: '58jgdko1rhv2d022j257ca66vr',
  region: 'us-west-2',
  domain: 'bsides-toolkit-auth.auth.us-west-2.amazoncognito.com',
};

function pickConfig(): CognitoEnvConfig | null {
  if (typeof window === 'undefined') return null;
  const host = window.location.hostname;
  if (host === 'localhost' || host === '127.0.0.1') return null;
  if (host === 'organize.bsidesboulder.org') return PROD_CONFIG;
  // dev domain, raw CloudFront URLs, anything else → dev config
  return DEV_CONFIG;
}

const picked = pickConfig();

export const authConfigEnabled = picked !== null;

export const authConfig = {
  Auth: {
    Cognito: {
      userPoolId: picked?.userPoolId || '',
      userPoolClientId: picked?.userPoolClientId || '',
      region: picked?.region || 'us-west-2',
      loginWith: {
        oauth: {
          domain: picked?.domain || '',
          scopes: ['openid', 'email', 'profile'],
          redirectSignIn: [window.location.origin + '/auth/callback'],
          redirectSignOut: [window.location.origin + '/login'],
          responseType: 'code' as const,
        },
      },
    },
  },
};
